module.exports = __webpack_public_path__ + "img/marker_urban.43fca676.svg";